import React, { Component, PropTypes } from 'react';
import styles from '../Header.scss';
import {isAuthenticated} from '../../../logic/authHelpers';
import UserMenu from '../../User/elements/MenuDropdown';

export default class HeaderAuthBlock extends Component {
  render() {
    if (isAuthenticated()) {
      return (
        <UserMenu className={styles.authBlock} {...this.props} />
      );
    }
    return (
      <div className={styles.authBlock}>
        <button onClick={this.props.actions.openSignInPopup}>Войти</button>
        <button onClick={this.props.actions.openRegistrationPopup}>Регистрация</button>
      </div>
    );
  }
}



HeaderAuthBlock.propTypes = {
  actions: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/components/Header/elements/HeaderAuthBlock.jsx
 **/